import React, { Component } from "react";
import { Form, Button } from "semantic-ui-react";

class FoundationInfo extends Component {
  render() {
    return (
      <Form>
        <Form.Field>
          <label>Foundation Information:</label>
          <Form.TextArea
            placeholder = "Text"
            rows = "7"
            value = {this.props.profile.information || ""}
            onChange = {this.props.handleChange}
          />
        </Form.Field>
        <Button
          primary
          size="large"
          content="Save And Finish"
          floated="right"
          onClick={() => this.props.handleSubmit()}
        />
        <Button
          size="large"
          content="Go Back"
          floated="right"
          onClick={() => this.props.handleStep("contact-info")}
        />
      </Form>
    );
  }
}

export default FoundationInfo;
